export default __webpack_public_path__ + "static/media/Rochelle_9781408315941.ca71c381.jpg";